import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EvaButtonModule } from '../eva-button/eva-button.module';
import { EvaMessageModule } from '../eva-message/eva-message.module';
import { MainTitleModule } from '../main-title/main-title.module';
import { TagTextModule } from '../tag-text/tag-text.module';
import { DescriptionDetailedCategoryComponent } from './description-detailed-category.component';
import { DescriptionDetailedGroupComponent } from './description-detailed-group.component';
import { DescriptionDetailedItemComponent } from './description-detailed-item.component';
import { DescriptionDetailedComponent } from './description-detailed.component';

@NgModule({
    imports: [
        CommonModule,
        EvaMessageModule,
        TagTextModule,
        MainTitleModule,
        EvaButtonModule
    ],
    exports: [
        DescriptionDetailedComponent,
        DescriptionDetailedItemComponent
    ],
    declarations: [
        DescriptionDetailedItemComponent,
        DescriptionDetailedCategoryComponent,
        DescriptionDetailedGroupComponent,
        DescriptionDetailedComponent
    ],
    providers: [],
})
export class DescriptionDetailedModule { }
